import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { SaveOrderLogInput } from './SaveOrderLogInput';
import { SaveOrderLogOutput } from './SaveOrderLogOutput';

export class SaveOrderLogService extends HttpServiceBase {

  handle = (input: SaveOrderLogInput): Promise<Result<SaveOrderLogOutput> | null> => {
    const promise = this.http.post<Result<SaveOrderLogOutput>, SaveOrderLogInput>(`${this.baseUrlSislogApi}/v2/order-log`, input);
    return promise;
  }
}